enum TraceLevel {
    None = 0,
    Error = 1,
    DebugError = 2,
    Warning = 3,
    Info = 4,
    Verbose = 5
}

export default TraceLevel;
